import React, { useCallback, useContext, useMemo, useState } from "react"
import SKLand from "@skland/one-bridge"
import { useInterval, useUpdateEffect } from "ahooks"
import classNames from "classnames"
import dayjs from "dayjs"
import { SafeAreaView, useLandscapeDisplayInfo } from "@hg/layouts"
import { useShowRoleSelect } from "@hg/one-account"

import { i18n } from "@/utils/i18n"
import Logo from "../../components/Logo"
import Menu from "../../components/Menu"
import { ESubPage, GlobalContext, IPageProps } from "../../context"
import i18nData from "../../locales/zh-CN.json"
import styles from "./index.module.less"

const endAt = dayjs("2025-02-21 15:00:00+08:00") // TODO: 改成从配置获取

const PagePreview: React.FC<IPageProps> = () => {
    const {
        state: { show, fontSize, user, hasRole },
        dispatch,
    } = useContext(GlobalContext)
    const { width, height } = useLandscapeDisplayInfo()

    const showRoleSelect = useShowRoleSelect()

    const [visible, setVisible] = useState(false)

    const [days, setDays] = useState(0)
    const [hour, setHour] = useState(0)
    const [minute, setMinute] = useState(0)
    const [second, setSecond] = useState(0)
    useInterval(
        () => {
            const now = dayjs()
            setDays(endAt.diff(now, "days"))
            setHour(now.get("hour"))
            setMinute(now.get("minute"))
            setSecond(now.get("second"))
        },
        100,
        {
            immediate: true,
        }
    )

    const scale = useMemo(() => {
        if (!width || !height) {
            return 1
        }

        if (width / height > 16 / 9) {
            return width / ((1920 / 16) * fontSize)
        } else {
            return height / ((1080 / 16) * fontSize)
        }
    }, [fontSize, height, width])

    useUpdateEffect(() => {
        if (show) {
            const tid = window.setTimeout(() => {
                setVisible(true)
            }, 1000)

            return () => {
                window.clearTimeout(tid)
            }
        }
    }, [show])

    const handleClickEntry = useCallback(
        (e: React.MouseEvent) => {
            e.stopPropagation()

            if (!user) {
                // 无角色 且 在森空岛内
                if (!hasRole && SKLand.getSystemInfo().isApp) {
                    showRoleSelect()
                    return
                }

                dispatch({
                    type: "updateContext",
                    payload: {
                        showRegistry: true,
                    },
                })
                return
            }

            dispatch({
                type: "updateContext",
                payload: {
                    currentSubPage: ESubPage.Game,
                },
            })
        },
        [dispatch, hasRole, showRoleSelect, user]
    )

    return (
        <div className={classNames(styles.page, visible && styles.show)}>
            <div
                className={styles.bg}
                style={{
                    transform: `translateX(-50%) scale(${scale})`,
                }}
            >
                <div className={styles.clock}>
                    <div
                        className={styles.second}
                        style={{
                            transform: `rotate(${second * 6}deg)`,
                        }}
                    />
                    <div
                        className={styles.day}
                        style={{
                            transform: `rotate(${360 - 60 * days}deg)`,
                        }}
                    />
                    <div
                        className={styles.hour}
                        style={{
                            transform: `rotate(${hour * 30}deg)`,
                        }}
                    />
                    <div
                        className={styles.minute}
                        style={{
                            transform: `rotate(${minute * 6}deg)`,
                        }}
                    />
                </div>
            </div>
            <SafeAreaView
                mode="margin"
                edges={["bottom"]}
                className={styles.title}
            />
            <SafeAreaView
                mode="margin"
                edges={["bottom"]}
                className={styles.countdown}
            >
                {String(days)
                    .split("")
                    .map((item, index) => (
                        <div
                            key={index}
                            data-num={item}
                            className={styles.num}
                        />
                    ))}
                <div className={styles.unit} />
            </SafeAreaView>
            <SafeAreaView
                mode="margin"
                edges={["right", "bottom"]}
                className={styles.game}
                onClick={handleClickEntry}
            >
                <div className={styles.book}></div>
                <div className={styles.label}>
                    <span>{i18n(i18nData, "subPage.game")}</span>
                </div>
            </SafeAreaView>
            <Logo className={styles.logo} />
            <Menu
                className={styles.menu}
                visible={visible}
                needAnimeDelay={false}
            />
        </div>
    )
}

export default PagePreview
